<script>
    export let item;

    function getSpan(){
        let output = {
            "mobile": {},
            "desktop": {}
        };
        const cols = {
            "mobile": 2,
            "desktop": 4
        };
        const grid = {
            "float": {
                "mobile": item.icon.length / cols.mobile % 1,
                "desktop": item.icon.length / cols.desktop % 1
            },
            "int": {
                "mobile": item.icon.length / cols.mobile | 0,
                "desktop": item.icon.length / cols.desktop | 0
            }
        };            
        if (grid.float.mobile > 0){
            output.mobile.start = grid.int.mobile * cols.mobile;
            const span = ( ( 1 - grid.float.mobile ) * cols.mobile ) / ( item.icon.length - grid.int.mobile * cols.mobile );
            for (let i = output.mobile.start; i < item.icon.length; i++){
                output.mobile[i] = span + 1 | 0;
            }
            if (span % 1 > 0){
                output.mobile[( item.icon.length - output.mobile.start - 1 / 2 | 0 ) - 1 ] = output.mobile[( item.icon.length - output.mobile.start - 1 / 2 | 0 ) - 1 ] + 1;
            }
        }
        if (grid.float.desktop > 0){
            output.desktop.start = grid.int.desktop * cols.desktop;
            const span = ( ( 1 - grid.float.desktop ) * cols.desktop ) / ( item.icon.length - grid.int.desktop * cols.desktop );
            for (let i = output.desktop.start; i < item.icon.length; i++){
                output.desktop[i] = span + 1 | 0;
            }
            if (span % 1 > 0){
                output.desktop[( item.icon.length - output.desktop.start - 1 / 2 | 0 ) - 1 ] = output.desktop[( item.icon.length - output.desktop.start - 1 / 2 | 0 ) - 1 ] + 1;
            }
        }
        return output;
    };

    const spanSettings = getSpan();

    function setSpan(idex) {
        let output = "";
        if ( spanSettings.mobile[idex] !== undefined ){
            output = output + "col-span-" + spanSettings.mobile[idex] + " ";
        }
        if ( spanSettings.desktop[idex] !== undefined ){
            output = output + "md:col-span-" + spanSettings.desktop[idex];
        } else {
            output = output + "md:col-span-1";
        }
        return output;
    }

</script>

<div class="bg-white">
    <div class="container mx-auto p-6">
        <div class="p-4 text-center text-4xl text-zinc-900 text">{item.title}</div>
        <div class="p-4 text-center text-zinc-900">{item.description}</div>
        {#if typeof item.icon !== 'undefined'}
            <div class="grid grid-cols-2 md:grid-cols-4 gap-8 p-4">
                {#each item.icon as image, i }
                    <picture class="place-self-center {setSpan(i)} p-4 max-h-24">
                        <source
                            srcset="{image.path}_88.heic"
                            type="image/heic"
                        />
                        <source
                            srcset="{image.path}_88.avif"
                            type="image/avif"
                        />
                        <source
                            srcset="{image.path}_88.webp"
                            type="image/webp"
                        />
                        <img alt="{item.name}" src="{image.path}_88.png"/>
                    </picture>
                {/each}
            </div>
        {/if}
    </div>
</div>